<template>
  <div class="modal fade" id="viewContactModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Contact</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col">
              <p class="text-secondary mb-1">Contact</p>
              <p class="mb-1">{{ Contact.Name }}</p>
              <p class="mb-1">{{ Contact.Email }}</p>
              <p class="mb-1">{{ Contact.Phone }}</p>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col">
              <p class="text-secondary mb-1">Address</p>
              <p class="mb-1">{{ Contact.Address_Line_1 }}</p>
              <p class="mb-1">{{ Contact.Address_Line_2 }}</p>
              <p class="mb-1">
                {{ Contact.City }}, {{ Contact.State }},
                {{ Contact.Zip }}
              </p>
            </div>
          </div>
          <div class="mt-4">
            <button
              class="btn btn-outline-secondary float-right"
              v-on:click="close"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "ViewContactModal",
  props: {
    Contact: Object
  },
  data() {
    return {};
  },
  methods: {
    close() {
      $("#viewContactModal").modal("hide");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
